// const { ManageAdministration } = CoreQueries;

const Model = {
  namespace: 'administration',

  state: {
    openCopyProcess: false,
  },

  effects: {
    *toggleCopyProcess({ payload: { state } }, { put }) {
      yield put({
        type: 'queryToggleCopyProcess',
        payload: {
          state,
        },
      });
    },
  },

  reducers: {
    queryToggleCopyProcess(state, { payload }) {
      return {
        ...state,
        openCopyProcess: payload.state,
      };
    },
  },
};

export default Model;
